import { 
    CREATEBLOODBANKBAGISSUE,
    CREATEBLOODBANKBAGISSUETRANSACTION,
    CREATEBLOODBANKBAGRECEIVE,
    CREATEBLOODBANKBAGRECEIVETRANSACTION,
    CREATEBLOODBANKCOMPONENT,
    CREATEBLOODBANKCOMPONENTISSUE,
    CREATEBLOODBANKCOMPONENTISSUETRANSACTION,
    CREATEBLOODBANKDONAR, 
    DELETEBLOODBANKBAGISSUE, 
    DELETEBLOODBANKBAGISSUETRANSACTION, 
    DELETEBLOODBANKBAGRECEIVE, 
    DELETEBLOODBANKBAGRECEIVETRANSACTION, 
    DELETEBLOODBANKCOMPONENT, 
    DELETEBLOODBANKCOMPONENTISSUE, 
    DELETEBLOODBANKCOMPONENTISSUETRANSACTION, 
    DELETEBLOODBANKDONAR, 
    GETBLOODBANKBAGISSUE, 
    GETBLOODBANKBAGISSUETRANSACTION, 
    GETBLOODBANKBAGRECEIVE, 
    GETBLOODBANKBAGRECEIVETRANSACTION, 
    GETBLOODBANKCOMPONENT, 
    GETBLOODBANKCOMPONENTISSUE, 
    GETBLOODBANKCOMPONENTISSUETRANSACTION, 
    GETBLOODBANKDONAR, 
    UPDATEBLOODBANKBAGISSUE, 
    UPDATEBLOODBANKBAGISSUETRANSACTION, 
    UPDATEBLOODBANKBAGRECEIVE, 
    UPDATEBLOODBANKBAGRECEIVETRANSACTION, 
    UPDATEBLOODBANKCOMPONENT, 
    UPDATEBLOODBANKCOMPONENTISSUE, 
    UPDATEBLOODBANKCOMPONENTISSUETRANSACTION, 
    UPDATEBLOODBANKDONAR 
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEBLOODBANKDONAR:
            return {
                ...state,
                    bloodbankdonorSaveStatus: action.payload.success,
            }
        case GETBLOODBANKDONAR:
                return {
                        ...state,
                        bloodbankdonorList: action.payload.data,
                        }
      
        case UPDATEBLOODBANKDONAR:
                return {
                        ...state,
                        bloodbankdonorUpdateStatus: action.payload.success,
                        }   

        case DELETEBLOODBANKDONAR:
                 return {
                     ...state,
                     bloodbankdonorDeleteStatus: action.payload.success,
                        } 
        case CREATEBLOODBANKBAGRECEIVE:
            return {
                ...state,
                    bloodbankbagreceiveSaveStatus: action.payload.success,
            }
        case GETBLOODBANKBAGRECEIVE:
                return {
                        ...state,
                        bloodbankbagreceiveList: action.payload.data,
                        }
      
        case UPDATEBLOODBANKBAGRECEIVE:
                return {
                        ...state,
                        bloodbankbagreceiveUpdateStatus: action.payload.success,
                        }   

        case DELETEBLOODBANKBAGRECEIVE:
                 return {
                     ...state,
                     bloodbankbagreceiveDeleteStatus: action.payload.success,
                        } 
        case CREATEBLOODBANKCOMPONENT:
            return {
                ...state,
                    bloodbankcomponentSaveStatus: action.payload.success,
            }
        case GETBLOODBANKCOMPONENT:
                return {
                        ...state,
                        bloodbankcomponentList: action.payload.data,
                        }
      
        case UPDATEBLOODBANKCOMPONENT:
                return {
                        ...state,
                        bloodbankcomponentUpdateStatus: action.payload.success,
                        }   

        case DELETEBLOODBANKCOMPONENT:
                 return {
                     ...state,
                     bloodbankcomponentDeleteStatus: action.payload.success,
                        } 
        case CREATEBLOODBANKBAGISSUE:
            return {
                ...state,
                    bloodbankbagissueSaveStatus: action.payload.success,
            }
        case GETBLOODBANKBAGISSUE:
                return {
                        ...state,
                        bloodbankbagissueList: action.payload.data,
                        }
      
        case UPDATEBLOODBANKBAGISSUE:
                return {
                        ...state,
                        bloodbankbagissueUpdateStatus: action.payload.success,
                        }   

        case DELETEBLOODBANKBAGISSUE:
                 return {
                     ...state,
                     bloodbankbagissueDeleteStatus: action.payload.success,
                        } 
        case CREATEBLOODBANKBAGISSUETRANSACTION:
            return {
                ...state,
                    bloodbankbagissuetransactionSaveStatus: action.payload.success,
            }
        case GETBLOODBANKBAGISSUETRANSACTION:
                return {
                        ...state,
                        bloodbankbagissuetransactionList: action.payload.data,
                        }
      
        case UPDATEBLOODBANKBAGISSUETRANSACTION:
                return {
                        ...state,
                        bloodbankbagissuetransactionUpdateStatus: action.payload.success,
                        }   

        case DELETEBLOODBANKBAGISSUETRANSACTION:
                 return {
                     ...state,
                     bloodbankbagissuetransactionDeleteStatus: action.payload.success,
                        } 
        case CREATEBLOODBANKCOMPONENTISSUE:
            return {
                ...state,
                    bloodbankcomponentissueSaveStatus: action.payload.success,
            }
        case GETBLOODBANKCOMPONENTISSUE:
                return {
                        ...state,
                        bloodbankcomponentissueList: action.payload.data,
                        }
      
        case UPDATEBLOODBANKCOMPONENTISSUE:
                return {
                        ...state,
                        bloodbankcomponentissueUpdateStatus: action.payload.success,
                        }   

        case DELETEBLOODBANKCOMPONENTISSUE:
                 return {
                     ...state,
                     bloodbankcomponentissueDeleteStatus: action.payload.success,
                        } 
        case CREATEBLOODBANKCOMPONENTISSUETRANSACTION:
            return {
                ...state,
                    bloodbankcomponentissuetransactionSaveStatus: action.payload.success,
            }
        case GETBLOODBANKCOMPONENTISSUETRANSACTION:
                return {
                        ...state,
                        bloodbankcomponentissuetransactionList: action.payload.data,
                        }
      
        case UPDATEBLOODBANKCOMPONENTISSUETRANSACTION:
                return {
                        ...state,
                        bloodbankcomponentissuetransactionUpdateStatus: action.payload.success,
                        }   

        case DELETEBLOODBANKCOMPONENTISSUETRANSACTION:
                 return {
                     ...state,
                     bloodbankcomponentissuetransactionDeleteStatus: action.payload.success,
                        }
        case CREATEBLOODBANKBAGRECEIVETRANSACTION:
            return {
                ...state,
                    bloodbankbagreceivetransactionSaveStatus: action.payload.success,
            }
        case GETBLOODBANKBAGRECEIVETRANSACTION:
                return {
                        ...state,
                        bloodbankbagreceivetransactionList: action.payload.data,
                        }
      
        case UPDATEBLOODBANKBAGRECEIVETRANSACTION:
                return {
                        ...state,
                        bloodbankbagreceivetransactionUpdateStatus: action.payload.success,
                        }   

        case DELETEBLOODBANKBAGRECEIVETRANSACTION:
                 return {
                     ...state,
                     bloodbankbagreceivetransactionDeleteStatus: action.payload.success,
                        }  
                        default:
                            return state
                             }
                         }